export default __webpack_public_path__ + "static/media/Sponcerimage19.e0123b9a.png";